import { Profile } from "../../../services/Invoices/InvoiceService/InvoiceService";
import { PartnerListData } from "./ColumnsConfig";


export const mapProfileToPartnerList = (
  profiles: Profile[]
): PartnerListData[] => {
  return profiles.map((profile, index) => ({
    key: index + 1,
    businessName: profile.businessName,
    role:profile.profileUsers?.map(u => u.roleName).join(", ") || "N/A",
    userId:profile.profileUsers?.map(u => u.userId).join(", ") || "N/A",
    status: profile.profileStatusName,
    profileId:profile.profileId,
    stepCompleted: profile.stepCompleted,
    loginEmail: profile.profileUsers?.map(u => u.userName).join(", ") || "N/A",
    businessEmail: profile.businessEmail,
    isFreelancer: profile.isFreelancer,
    receiveCurrency: profile.receiveCurrency,
    receiveCountryCode: profile.receiveCountryCode,
    individualName: profile.individualName
  }));
};
